var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen p-8 motor-commercial-page bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50"},[_c('MotorCommercialFlow',{attrs:{"product-id":"MC101","class-code":"MotorCommercial"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }